import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Toaster } from '@/components/ui/toaster'
import { AuthProvider } from '@/components/AuthProvider'
import ProtectedRoute from '@/components/ProtectedRoute'

// Marketing Pages
import MarketingLayout from '@/components/layouts/MarketingLayout'
import HomePage from '@/pages/marketing/HomePage'
import PricingPage from '@/pages/marketing/PricingPage'
import FeaturesPage from '@/pages/marketing/FeaturesPage'
import DocsPage from '@/pages/marketing/DocsPage'
import CaseStudiesPage from '@/pages/marketing/CaseStudiesPage'

// Dashboard Pages
import DashboardLayout from '@/components/layouts/DashboardLayout'
import Overview from '@/pages/Overview'
import RegisterPage from '@/pages/auth/RegisterPage'
import SmsSend from '@/pages/SmsSend'
import SmsRecords from '@/pages/SmsRecords'
import Templates from '@/pages/Templates'
import Signatures from '@/pages/Signatures'
import Account from '@/pages/Account'
import Recharge from '@/pages/Recharge'
import Transactions from '@/pages/Transactions'
import AccountSettings from '@/pages/AccountSettings'
import Settings from '@/pages/Settings'
import Reports from '@/pages/Reports'
import ApiKeyManagement from '@/pages/ApiKeyManagement'
import WebhookManagement from '@/pages/WebhookManagement'
import MoMessages from '@/pages/MoMessages'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <Routes>
            {/* 根路径直接显示首页 */}
            <Route path="/" element={
              <MarketingLayout />
            }>
              <Route index element={<HomePage />} />
              <Route path="pricing" element={<PricingPage />} />
              <Route path="register" element={<RegisterPage />} />
              <Route path="docs" element={<DocsPage />} />
              <Route path="contact" element={<div className="p-8">联系我们页面 - 开发中</div>} />
              <Route path="features" element={<FeaturesPage />} />
              <Route path="cases" element={<CaseStudiesPage />} />
              <Route path="help" element={<div className="p-8">帮助中心页面 - 开发中</div>} />
            </Route>

            {/* Marketing Routes (兼容旧路由) */}
            <Route path="/marketing" element={<Navigate to="/" replace />} />
            <Route path="/marketing/*" element={<Navigate to="/" replace />} />

            {/* Dashboard Routes (Requires Login) */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Overview />} />
              <Route path="send" element={<SmsSend />} />
              <Route path="records" element={<SmsRecords />} />
              <Route path="mo-messages" element={<MoMessages />} />
              <Route path="templates" element={<Templates />} />
              <Route path="signatures" element={<Signatures />} />
              <Route path="account" element={<Account />} />
              <Route path="account/recharge" element={<Recharge />} />
              <Route path="account/transactions" element={<Transactions />} />
              <Route path="account/usage" element={<div className="p-6">用量统计（占位）</div>} />
              <Route path="settings/account" element={<AccountSettings />} />
              <Route path="settings/security" element={<div className="p-6">安全设置（占位）</div>} />
              <Route path="settings/organization" element={<div className="p-6">组织与权限（占位）</div>} />
              <Route path="settings/notifications" element={<div className="p-6">通知设置（占位）</div>} />
              <Route path="credentials/api-keys" element={<ApiKeyManagement />} />
              <Route path="credentials/webhooks" element={<WebhookManagement />} />
              <Route path="settings" element={<Settings />} />
              <Route path="reports" element={<Reports />} />
            </Route>
            
            {/* 其他路由重定向到根路径 */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster />
          <ReactQueryDevtools initialIsOpen={false} />
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  )
}

export default App
